(function () {
  function initCtrInstructions(container) {
    var steps = container.querySelectorAll('[data-ctr-step]');

    steps.forEach(function (step) {
      var toggle = step.querySelector('[data-ctr-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = step.classList.contains('is-open');

        steps.forEach(function (s) {
          s.classList.remove('is-open');
          var t = s.querySelector('[data-ctr-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          step.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ctr-instructions]').forEach(initCtrInstructions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ctr-instructions]');
    if (section) initCtrInstructions(section);
  });
})();
